import { store } from "../state/store.js";
import { isMobileLayout, syncMobileFavVisibility } from "./mobile.js";
import { updateUI } from "./updateUI.js";

export function wireTabs(){
  document.querySelectorAll(".tab").forEach(btn=>{
    btn.addEventListener("click", ()=>switchTab(btn.dataset.tab));
  });
  document.querySelectorAll(".fav-subtab").forEach(btn=>{
    btn.addEventListener("click", ()=>switchFavView(btn.dataset.favtab));
  });
}

export function switchTab(tab){
  store.ui.tab = tab;
  document.querySelectorAll(".tab").forEach(b=>b.classList.toggle("active", b.dataset.tab===tab));
  document.querySelectorAll(".panel").forEach(p=>p.classList.toggle("active", p.id===`panel-${tab}`));
  if (tab === "fav" && isMobileLayout()) syncMobileFavVisibility(store.ui?.favTab || "fta");
  updateUI();
  window.dispatchEvent(new Event("app-layoutchange"));
}

export function switchFavView(favtab){
  store.ui.favTab = favtab;
  document.querySelectorAll(".fav-subtab").forEach(b=>b.classList.toggle("active", b.dataset.favtab===favtab));
  if (isMobileLayout()) {
    syncMobileFavVisibility(favtab);
  } else {
    const map = { fta:"favFtaWrap", sky:"favSkyWrap", hd:"favHdWrap", k20:"favK20Wrap", own:"favOwnWrap" };
    for(const [k,id] of Object.entries(map)){
      const node = document.getElementById(id);
      if(node) node.style.display = (k===favtab) ? "" : "none";
    }
  }
  updateUI();
  window.dispatchEvent(new Event("app-layoutchange"));
}
